import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // 🔥 Ye import zaroori hai

const firebaseConfig = {
  apiKey: "AIzaSyAF_6ZhDv1V5kRMuy82mo0mFOi3fFskKsE",
  authDomain: "lms-crm-e79ec.firebaseapp.com",
  projectId: "lms-crm-e79ec",
  storageBucket: "lms-crm-e79ec.firebasestorage.app",
  messagingSenderId: "825295836304",
  appId: "1:825295836304:web:1d61a9c6182118d05c7415"
};

// 1. App Initialize
const app = initializeApp(firebaseConfig);

// 2. Database Initialize
export const db = getFirestore(app);

// 3. 🔥 Auth Initialize & Export (Ye missing tha)
export const auth = getAuth(app);
export { firebaseConfig };